// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/icon-info.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RWrapper{
    box-sizing: border-box;
    margin: auto;
    display: flex;
}

.Elev-cmt{
    color: black;
    font-size: 16px;
    font-weight: 600;
}

h3 {
    text-align: center;
}

.errMsg {
    color: #fe5353;;
}

.flight-details {
    padding: 10px;
}

.flight-details .rows {
    display: flex;
    justify-content: space-between;
}
.details-sections {
    width: 33%;
    display: flex;
    justify-content: flex-start;
}

.details-sections p {
    margin: 0
}

.flight-details label {
    font-weight: bold;
}

.mr-sm {
    margin-right: 3px;
}

.button-section {
    padding: 6px;
    padding-bottom: 11px;
    display: flex;
    justify-content: flex-end;
}

.print-report-btn {
    margin: 5px;
    background-color: #477afe;
    color: #fff;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    border: none;
    cursor: pointer;
}

.generate-report-btn {
    margin: 5px;
    background-color: transparent;
    border-radius: 8px;
    border: 1px solid #477afe;
    color: #477afe;
    padding: 10px 16px;
    font-size: 14px;
    cursor: pointer;
}

.back-btn-img {
    cursor: pointer;
    width: 40px;
    margin-right: 5px;
}

.left-section {
    width: 35%;
    height: calc(100vh - 60px);
}

.right-section {
    width: 65%;
}

.left-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.left-top-header {
    display: flex;
}

.left-section .left-top-part {
    font-size: 16px;
    padding: 4px 12px;
}

.label-name {
    font-weight: bold;
}

.mb-1 {
    margin-bottom: 5px;
}

.d-flex {
    display: flex;
}

.w-45 {
    width: 43%;
} 

.blue-box {
    padding: 8px;
    font-size: 16px;
    border-radius: 8px;
    background-color: #f5f8ff;
    border: 1px solid  #e1e7f5;
    display: flex;
}

.blue-box-container-1 {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}

.blue-box-large {
    margin-top: 20px;
    padding: 8px;
    border-radius: 8px;
    background-color: #f5f8ff;
    border: 1px solid  #e1e7f5;
}
.blue-box-row {
    display: flex;
    justify-content: space-between;
}
.label-cont {

}
.mr-1 {
    margin-right: 4px;
}
.icon-margin {
    margin-right: 4px;
    margin-top: 3px;
}
.mt-20 {
    margin-top: 30px;
}

.warning-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
    width: 16px;
    height: 16px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.block {
    display: block;
}

.ml-2 {
    margin-left: 10px;
}

.mt-2 {
    margin-top: 15px;
}

.graph-map-tabs-wrap{
    height: 50px;
    display: flex;
    justify-content: center;
}

.button-tab{
    width: 200px;
    padding-top: 10px;
    border: none;
    width: 100px;
    color: #477afe;
    background-color: transparent;
    font-family: 'IBM-Plex-sans-semibold';
    font-size: 14px;
    cursor: pointer;
}

.button-tab-active{
    border-bottom: 2px solid #477afe;
}

.hide-div{
    /* display: none; */
    visibility: hidden;
    height: 0px;
    min-height: 0px !important;
    overflow: hidden;
}

.kmlMap{
    min-height: 500px;
}

.-G {
    width: 40px;
    height: 20px;
    margin: 0 0 0 4px;
    font-family: IBMPlexSans;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.18px;
    color: #121212;
  }
  .FlightDetailsWrapper{
    max-height:calc(100vh - 200px);
    overflow-y: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/Report.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;;AAEA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,yDAAkD;IAClD,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,qCAAqC;IACrC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB","sourcesContent":[".RWrapper{\n    box-sizing: border-box;\n    margin: auto;\n    display: flex;\n}\n\n.Elev-cmt{\n    color: black;\n    font-size: 16px;\n    font-weight: 600;\n}\n\nh3 {\n    text-align: center;\n}\n\n.errMsg {\n    color: #fe5353;;\n}\n\n.flight-details {\n    padding: 10px;\n}\n\n.flight-details .rows {\n    display: flex;\n    justify-content: space-between;\n}\n.details-sections {\n    width: 33%;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.details-sections p {\n    margin: 0\n}\n\n.flight-details label {\n    font-weight: bold;\n}\n\n.mr-sm {\n    margin-right: 3px;\n}\n\n.button-section {\n    padding: 6px;\n    padding-bottom: 11px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.print-report-btn {\n    margin: 5px;\n    background-color: #477afe;\n    color: #fff;\n    border-radius: 8px;\n    padding: 10px 16px;\n    font-size: 14px;\n    border: none;\n    cursor: pointer;\n}\n\n.generate-report-btn {\n    margin: 5px;\n    background-color: transparent;\n    border-radius: 8px;\n    border: 1px solid #477afe;\n    color: #477afe;\n    padding: 10px 16px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.back-btn-img {\n    cursor: pointer;\n    width: 40px;\n    margin-right: 5px;\n}\n\n.left-section {\n    width: 35%;\n    height: calc(100vh - 60px);\n}\n\n.right-section {\n    width: 65%;\n}\n\n.left-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.left-top-header {\n    display: flex;\n}\n\n.left-section .left-top-part {\n    font-size: 16px;\n    padding: 4px 12px;\n}\n\n.label-name {\n    font-weight: bold;\n}\n\n.mb-1 {\n    margin-bottom: 5px;\n}\n\n.d-flex {\n    display: flex;\n}\n\n.w-45 {\n    width: 43%;\n} \n\n.blue-box {\n    padding: 8px;\n    font-size: 16px;\n    border-radius: 8px;\n    background-color: #f5f8ff;\n    border: 1px solid  #e1e7f5;\n    display: flex;\n}\n\n.blue-box-container-1 {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.blue-box-large {\n    margin-top: 20px;\n    padding: 8px;\n    border-radius: 8px;\n    background-color: #f5f8ff;\n    border: 1px solid  #e1e7f5;\n}\n.blue-box-row {\n    display: flex;\n    justify-content: space-between;\n}\n.label-cont {\n\n}\n.mr-1 {\n    margin-right: 4px;\n}\n.icon-margin {\n    margin-right: 4px;\n    margin-top: 3px;\n}\n.mt-20 {\n    margin-top: 30px;\n}\n\n.warning-icon {\n    background-image: url(\"/src/Images/icon-info.svg\"); \n    width: 16px;\n    height: 16px;\n    display: inline-block;\n    position: relative;\n    top: 2px;\n}\n\n.block {\n    display: block;\n}\n\n.ml-2 {\n    margin-left: 10px;\n}\n\n.mt-2 {\n    margin-top: 15px;\n}\n\n.graph-map-tabs-wrap{\n    height: 50px;\n    display: flex;\n    justify-content: center;\n}\n\n.button-tab{\n    width: 200px;\n    padding-top: 10px;\n    border: none;\n    width: 100px;\n    color: #477afe;\n    background-color: transparent;\n    font-family: 'IBM-Plex-sans-semibold';\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.button-tab-active{\n    border-bottom: 2px solid #477afe;\n}\n\n.hide-div{\n    /* display: none; */\n    visibility: hidden;\n    height: 0px;\n    min-height: 0px !important;\n    overflow: hidden;\n}\n\n.kmlMap{\n    min-height: 500px;\n}\n\n.-G {\n    width: 40px;\n    height: 20px;\n    margin: 0 0 0 4px;\n    font-family: IBMPlexSans;\n    font-size: 16px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: 0.18px;\n    color: #121212;\n  }\n  .FlightDetailsWrapper{\n    max-height:calc(100vh - 200px);\n    overflow-y: auto;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
